module.exports = "//d274d294w9cx2v.cloudfront.net/353b389525a5cf05917352028e0fa45d19ef128a/images/digital-invites.jpg";